import React from 'react';
import { X } from 'lucide-react';
import { Section } from './Shared';
export const PainPoints = () => {
  const points = ['Llegás al día 15 del mes con saldo en rojo y sin saber por qué', 'Pagás el mínimo de la tarjeta y el mes siguiente debe más', 'Trabajás cada vez más y la sensación de escasez no desaparece', 'Intentaste la ley de atracción pero "en Argentina eso no funciona"', 'Tenés deudas que se sienten eternas, sin un plan real de salida', 'El estrés financiero te roba el sueño, la paciencia y la energía', 'Cerrás el domingo con angustia, resignación y vuelta a empezar'];
  return <Section className="max-w-4xl" data-id="element-217">
      <div className="text-center mb-12" data-id="element-218">
        <h2 className="md:text-5xl font-serif font-bold mb-6 text-[22px]" data-id="element-219">
          ¿Cuántas noches más vas a quedarte con ese nudo en el estómago?
        </h2>
        <p className="text-brand-text/80 mb-4 text-[12px]" data-id="element-220">
          Vivís en Argentina. Sabés lo que es el esfuerzo.
        </p>
        <p className="text-brand-text/80 mb-4 text-[12px]" data-id="element-221">
          Pero nadie te dijo que ibas a pasar los domingos mirando el resumen de
          la tarjeta con angustia, calculando si llegás a fin de mes, pensando
          que todo lo que ganás se evapora antes de que lo puedas tocar.
        </p>
        <p className="text-xl font-medium text-brand-gold mt-6" data-id="element-222">
          No es falta de trabajo. Es falta de un sistema.
        </p>
      </div>

      <div className="glass-panel p-8 md:p-10 rounded-3xl mb-12 pt-[3px] pb-[3px] space-y-[14px] bg-white/60 border-brand-pink/30" data-id="element-223">
        <h3 className="font-medium mb-6 flex items-center text-brand-text/90 text-[18px]" data-id="element-224">
          <X className="w-6 h-6 text-red-500 mr-2" data-id="element-225" /> Lo que pasa sin el Código
          de Abundancia:
        </h3>
        <ul className="space-y-4" data-id="element-226">
          {points.map((point, i) => <li key={i} className="flex items-start" data-id="element-227">
              <X className="w-5 h-5 text-red-400 mr-3 mt-0.5 shrink-0" data-id="element-228" />
              <span className="text-brand-text/80 text-[12px]" data-id="element-229">{point}</span>
            </li>)}
        </ul>
      </div>

      <div className="text-center" data-id="element-230">
        <h3 className="md:text-3xl font-serif font-bold gold-gradient-text text-[22px]" data-id="element-231">
          ¿Y si este fuera el último domingo que pasás así?
        </h3>
      </div>
    </Section>;
};